import {AxesHelper, BufferGeometry, Float32BufferAttribute, LineBasicMaterial} from "three";

export class MultisizeAxesHelper extends AxesHelper {
    constructor( sizeX = 1, sizeY = 1, sizeZ = 1) {
        super(sizeX);

        const vertices = [
            0, 0, 0,	sizeX, 0, 0,
            0, 0, 0,	0, sizeY, 0,
            0, 0, 0,	0, 0, sizeZ
        ];

        const colors = [
            1, 0, 0,	1, 0.6, 0,
            0, 1, 0,	0.6, 1, 0,
            0, 0, 1,	0, 0.6, 1
        ];

        const geometry = new BufferGeometry();
        geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
        geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

        const material = new LineBasicMaterial( { vertexColors: true, toneMapped: false } );

        this.geometry = geometry;
        this.material = material;

        this.updateMorphTargets();

        this.type = 'MultisizeAxesHelper';
    }
}